(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["velune-video-reels-block"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('velune-product-reels')) {
  customElements.define('velune-product-reels', class extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;
      this.track = this.querySelector('[data-vr-track]');
      this.videos = Array.from(this.querySelectorAll('[data-vr-video]'));
      if (!this.track || !this.videos.length) return;
      this._isVisible = false;
      this._onClick = (event) => {
        const playButton = event.target.closest('[data-vr-play]');
        if (playButton && this.contains(playButton)) {
          const clickedVideo = playButton.closest('[data-vr-card]')?.querySelector('[data-vr-video]');
          if (!clickedVideo) return;
          this.videos.forEach(video => { if (video !== clickedVideo) video.pause(); });
          this._play(clickedVideo);
          return;
        }
        const button = event.target.closest('[data-vr-sound]');
        if (!button || !this.contains(button)) return;
        const video = button.closest('[data-vr-card]')?.querySelector('[data-vr-video]');
        if (!video) return;
        const activate = video.muted;
        this.videos.forEach((other) => {
          if (other !== video) {
            other.muted = true;
            const otherButton = other.closest('[data-vr-card]')?.querySelector('[data-vr-sound]');
            if (otherButton) {
              otherButton.setAttribute('aria-pressed', 'false');
              otherButton.setAttribute('aria-label', 'Enable sound');
            }
          }
        });
        video.muted = !activate;
        button.setAttribute('aria-pressed', String(activate));
        button.setAttribute('aria-label', activate ? 'Disable sound' : 'Enable sound');
        if (activate) this._play(video);
      };
      this._onVisibilityChange = () => this._sync();
      this.addEventListener('click', this._onClick);
      document.addEventListener('visibilitychange', this._onVisibilityChange);
      this.videos.forEach((video) => {
        video.muted = true;
        video.defaultMuted = true;
        const poster = video.closest('[data-vr-card]')?.querySelector('.vr-poster');
        if (poster) video.addEventListener('playing', () => { poster.hidden = true; }, { once: true });
        video.addEventListener('playing', () => video.closest('[data-vr-card]')?.classList.add('vr-item--playing'));
        video.addEventListener('pause', () => video.closest('[data-vr-card]')?.classList.remove('vr-item--playing'));
      });
      if ('IntersectionObserver' in window) {
        this._sectionObserver = new IntersectionObserver((entries) => {
          this._isVisible = Boolean(entries[0]?.isIntersecting);
          this._sync();
        }, { rootMargin: '100px 0px', threshold: .05 });
        this._sectionObserver.observe(this);
        this._videoObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            entry.target.dataset.vrVisible = String(entry.isIntersecting && entry.intersectionRatio >= .55);
          });
          this._sync();
        }, { root: this.track, threshold: [0, .25, .55, .75, 1] });
        this.videos.forEach(video => this._videoObserver.observe(video));
      } else {
        this._isVisible = true;
        this._sync();
      }
    }
    _play(video) {
      if (!video || document.hidden || !this._isVisible || !video.paused) return;
      const result = video.play();
      if (result?.catch) result.catch(() => {});
    }
    _sync() {
      if (!this.videos) return;
      this.videos.forEach((video, index) => {
        if (!this._isVisible || document.hidden) {
          video.pause();
          return;
        }
        if (this.dataset.vrAutoplay !== 'true') {
          if (video.dataset.vrVisible === 'false') video.pause();
          return;
        }
        const canPlay = index < 3 || video.dataset.vrVisible === 'true';
        if (canPlay) this._play(video);
        else video.pause();
      });
    }
    disconnectedCallback() {
      this._sectionObserver?.disconnect();
      this._videoObserver?.disconnect();
      if (this._onClick) this.removeEventListener('click', this._onClick);
      if (this._onVisibilityChange) document.removeEventListener('visibilitychange', this._onVisibilityChange);
      this.videos?.forEach(video => video.pause());
      this._initialized = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
